import { connect } from 'react-redux';
import PartnerSignup from './partnerSignup';
import {
    getPartnerSignupErrorCode,
    getPartnerSignupStatus,
    getPartnerSignupIsLoading,
    getPartnerSignupEmailSent,
} from './selector';
import { submitPartnerSignupForm, resendPartnerConfirmationEmail } from './actions';

const mapStateToProps = state => {
    return {
        status: getPartnerSignupStatus(state),
        errorCode: getPartnerSignupErrorCode(state),
        isLoading: getPartnerSignupIsLoading(state),
        emailSent: getPartnerSignupEmailSent(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSubmitClick: data => {
            dispatch(submitPartnerSignupForm(data));
        },
        onResendClick: email => {
            dispatch(resendPartnerConfirmationEmail(email));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerSignup);
